export default "__VITE_ASSET__C70$6BZk__"